import React,{setState, useContext, useState} from 'react'
import { Button, Form,Icon } from 'semantic-ui-react'
import { useSelector } from 'react-redux';
import { Accordion, AccordionItem } from '../../../../commonComponents/accordion'
import ActorItemProvider from './Actors/actorItemProvider';
import { Exporter, Buyer, Seller,Consignee } from './Actors';
import ActorDetailHeader from './actorDetailHeader';
import {useCurrentShipmentType} from '../../../../hooks/useCurrentShipmentType'


function ItemParties(props) {
  
  const [isActive,setIsActive] = useState(false)
  const {isImportShipment} = useCurrentShipmentType()
  const invoiceId = props.invoiceId
  const isFormDisabled  = false
  const translate = (abc) => {
    return abc
  }

  return (
    <>
    {!isActive?
     <Button fluid
       style={{marginTop:'10px',marginBottom:'10px', backgroundColor:'#FFFFFF', textTransform: 'uppercase',}}
       id={`inActive-expandCollapseInvoiceParties-${invoiceId}`}
       onClick={()=>setIsActive(true)}>
        <div>
          <Icon name="plus circle" ></Icon>
        <strong>PARTIES</strong>    
        </div>
    </Button>  :

    <Form.Group className='float-container mg-t-15' widths='equal'>
      <div
       onClick={()=>setIsActive(false)}
       id={`active-expandCollapseInvoiceParties-${invoiceId}`}
        style={{
          textTransform: 'uppercase',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
         <Icon name="minus circle" ></Icon>
        <strong>PARTIES</strong>
      </div>

      <div>
       <ActorItemProvider>
        <Accordion translate={translate}>
          {isImportShipment &&
        <>
        <AccordionItem idText={"exportShow"} id="exporter" translate={translate} title={(props)=>(
          <ActorDetailHeader invoiceId={invoiceId} title="Exporter" actorType="exporter" boxNumber="3/1" {...props}></ActorDetailHeader>
       )}>
        <Exporter invoiceId={invoiceId} />
        </AccordionItem>
        <AccordionItem idText={"SellerShow"} id="seller" translate={translate} title={(props)=>(
          <ActorDetailHeader invoiceId={invoiceId}  title="Seller" actorType="seller" boxNumber="3/24" {...props}></ActorDetailHeader>
       )}>
       <Seller invoiceId={invoiceId} />
        </AccordionItem>
        <AccordionItem idText={"buyerShow"} id="buyer" translate={translate} title={(props)=>(
          <ActorDetailHeader invoiceId={invoiceId}  title="Buyer" actorType="buyer"boxNumber="3/26" {...props}></ActorDetailHeader>
       )}>
         <Buyer invoiceId={invoiceId} />
        </AccordionItem>
        </>
        }
 
       {
       !isImportShipment &&  
        <AccordionItem idText={"consigneeShow"} id="consignee" translate={translate} title={(props)=>(
          <ActorDetailHeader invoiceId={invoiceId}  title="Consignee" actorType="consignee"boxNumber="3/9" {...props}></ActorDetailHeader>
       )}>
         <Consignee invoiceId={invoiceId} />
        </AccordionItem>

       }
      
  
        </Accordion>
       </ActorItemProvider>
      </div>
    </Form.Group>
     }
    </>
     
  )
}

export default React.memo(ItemParties)
